/**
 * 自定义指令集合
 * @creater liux
 * @Email   liuxing@autobio.com.cn
 * @Date    2019年8月8日 10:00:00
 */
 import _ from 'lodash'
//input 自动聚焦
const focus = {
  inserted: function (el) {
    el.querySelector('input').focus();
  }
};
//button 连续点击
const throttle = {
  inserted: function (el, binding) {
    el.addEventListener('click', () => {
      el.style.pointerEvents = 'none';
      if (!el.disabled) {
        setTimeout(() => {
          el.style.pointerEvents = 'auto';
        }, binding.value || 1000);
      }
    });
  }
}

/**
 * @msg: 下拉框滚动分页加载
 */
 const selectLoadMore = {
  bind(el, binding, vnode) {
    if(typeof binding.value !== 'function') {
      throw new Error('selectLoadMore指令绑定的应是函数');
    }
    const vm = vnode.context;
    let maxHeight = 0;   // 内容区的最大高度
    const distance = 50; // 预加载高度
    const selectWrap = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
    const fun = _.debounce(() => {
      binding.value();
    }, 200);

    selectWrap.addEventListener('scroll', function() {
      let dynamic = this.clientHeight + this.scrollTop;
      if (vm.isResetQuery) {
        selectWrap.scrollTop = 0;
        maxHeight = 0;
        vm.$set(vm, 'isResetQuery', false);
      }
      if(maxHeight < dynamic) {
        maxHeight = dynamic;
        let isEnd = (dynamic + distance >= this.scrollHeight);
        isEnd && fun();        
      }
    })
  }
}

// 设置默认溢出显示数量
var spillDataNum = 20;

// 设置隐藏函数
var timeout = false;
let setRowDisableNone = function (topNum, showRowNum, binding) {
  if (timeout) {
    clearTimeout(timeout);
  }
  timeout = setTimeout(() => {
    binding.value.call(null, topNum, topNum + showRowNum + spillDataNum);
  });
};

const loadmore =  {
  name: 'loadmore',
  componentUpdated: function (el, binding, vnode, oldVnode) {
    setTimeout(() => {
      const dataSize = vnode.data.attrs['data-size'];
      const oldDataSize = oldVnode.data.attrs['data-size'];
      if(dataSize === oldDataSize){
        return;
      }
      const selectWrap = el.querySelector('.el-table__body-wrapper');
      const selectTbody = selectWrap.querySelector('table tbody');
      const selectRow = selectWrap.querySelector('table tr');
      if (!selectRow) {
        return;
      }
      const rowHeight = selectRow.clientHeight;
      let showRowNum = Math.round(selectWrap.clientHeight / rowHeight);

      const createElementTR = document.createElement('tr');
      let createElementTRHeight = (dataSize - showRowNum - spillDataNum) * rowHeight;
      createElementTR.setAttribute('style', `height: ${createElementTRHeight}px;`);
      selectTbody.append(createElementTR);

      // 监听滚动后事件
      selectWrap.addEventListener('scroll', function () {
        let topPx = this.scrollTop - spillDataNum * rowHeight;
        let topNum = Math.round(topPx / rowHeight);
        let minTopNum = dataSize - spillDataNum - showRowNum;
        if (topNum > minTopNum) {
          topNum = minTopNum;
        }
        if (topNum < 0) {
          topNum = 0;
          topPx = 0;
        }
        selectTbody.setAttribute('style', `transform: translateY(${topPx}px)`);
        createElementTR.setAttribute('style', `height: ${createElementTRHeight-topPx > 0 ? createElementTRHeight-topPx : 0}px;`);
        setRowDisableNone(topNum, showRowNum, binding);
      })
    });
  }
};

export default {
  focus,throttle,selectLoadMore,loadmore
}